import { translate } from './i18n';
export const formatDate = (date, format) => translate(`{{date, ${format}}}`, { date });
